<div class="page-top-banner">
  <h1>Tableau de bord</h1>

  <div class="action-zone">
    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Plateforme :</mat-label>
      <mat-select [(ngModel)]="platform" (ngModelChange)="onPlatformChange()">
        <mat-option value="Centrex NG">Centrex NG</mat-option>
        <mat-option value="Centrex Enreach">Centrex Enreach</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="dashboard-grid">
  @if (usersChart) {
  <mat-card>
    <h3>Utilisateurs</h3>
    <apx-chart [series]="usersChart.series" [chart]="usersChart.chart" [labels]="usersChart.labels"
      [colors]="usersChart.colors" [legend]="usersChart.legend" [plotOptions]="usersChart.plotOptions"
      [dataLabels]="usersChart.dataLabels">
    </apx-chart>
  </mat-card>
  }

  @if (extensionsChart) {
  <mat-card>
    <h3>Groupes Extensions</h3>
    <apx-chart [series]="extensionsChart.series" [chart]="extensionsChart.chart" [labels]="extensionsChart.labels"
      [colors]="extensionsChart.colors" [legend]="extensionsChart.legend" [plotOptions]="extensionsChart.plotOptions"
      [dataLabels]="extensionsChart.dataLabels">
    </apx-chart>
  </mat-card>
  }

  @if (sdasChart) {
  <mat-card>
    <h3>SDA</h3>
    <apx-chart [series]="sdasChart.series" [chart]="sdasChart.chart" [labels]="sdasChart.labels"
      [colors]="sdasChart.colors" [legend]="sdasChart.legend" [plotOptions]="sdasChart.plotOptions"
      [dataLabels]="sdasChart.dataLabels">
    </apx-chart>
  </mat-card>
  }

  @if (devicesChart) {
  <mat-card>
    <h3>Périphériques</h3>
    <apx-chart [series]="devicesChart.series" [chart]="devicesChart.chart" [labels]="devicesChart.labels"
      [colors]="devicesChart.colors" [legend]="devicesChart.legend" [plotOptions]="devicesChart.plotOptions"
      [dataLabels]="devicesChart.dataLabels">
    </apx-chart>
  </mat-card>
  }
</div>
<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.8)" color="#00D2B4" size="large" type="timer"
  [fullScreen]="false"></ngx-spinner>